import type { Header } from '@/components/partials/jobs/JobsBackOffice/JobsBackOfficeTable/types';
import { JobsModeratorsEmployersContractsContract, JobsModeratorsEmployerSortField } from '@/types/graphql';

export const HEADERS: Header[] = [
  { label: 'Company name', width: 250, sortBy: JobsModeratorsEmployerSortField.CompanyName },
  { label: 'Open vac.', width: 82 },
  { label: 'Head#', width: 67 },
  { label: 'ATS', width: 57 },
  { label: 'Plan', width: 76 },
  { label: 'Contract type', width: 160 },
  { label: 'In Review', width: 90, sortBy: JobsModeratorsEmployerSortField.HiringsToReviewCount },
  { label: 'Expiring', width: 80, sortBy: JobsModeratorsEmployerSortField.HiringsToExpireCount },
  { label: 'Intro', width: 58, sortBy: JobsModeratorsEmployerSortField.HiringsIntroducedCount },
  { label: 'Scheduled', width: 96, sortBy: JobsModeratorsEmployerSortField.HiringsScheduledCount },
  { label: 'Interviewed', width: 102, sortBy: JobsModeratorsEmployerSortField.HiringsInterviewedCount },
  { label: 'Offer', width: 60, sortBy: JobsModeratorsEmployerSortField.HiringsOfferedCount },
  { label: 'Hired', width: 62, sortBy: JobsModeratorsEmployerSortField.HiringsHiredCount },
  { label: 'Last review', width: 100, sortBy: JobsModeratorsEmployerSortField.DaysSinceLastHiringReviewed },
  { label: 'Account owner', width: 206 },
];

export const CONTRACT_TYPES_DICT = {
  [JobsModeratorsEmployersContractsContract.Payg]: 'PAYG',
  [JobsModeratorsEmployersContractsContract.SideHustle]: '100% Commission',
  [JobsModeratorsEmployersContractsContract.Saas]: 'AYCH',
  [JobsModeratorsEmployersContractsContract.Contract]: 'Contract-Hire',
  [JobsModeratorsEmployersContractsContract.SelfServePayg]: 'Self-serve PAYG',
};
